<template>
  <div class="Animation">
      <div id="topContainer">

        <div id="demo1"></div>
        <div id="demo2">
          <iframe allowfullscreen="" src="//www.youtube.com/embed/PndByiL3i3Q?rel=0&showinfo=0"  frameborder="0" height="331" width="560" padding="22px"></iframe>
          </div>
          <div id="demo3"></div>
          <div id="demo4"></div>
          <div id="demo5">
          <iframe allowfullscreen="" src="//www.youtube.com/embed/a08FROYde50?rel=0&showinfo=0" frameborder="0" height="209" width="304" padding="15px"></iframe>
          </div>                                                                                                                             
          <div id="demo6"></div>                                                                                                             
          <div id="demo7">                                                                                                                   
          <iframe allowfullscreen="" src="//www.youtube.com/embed/N1IE2TMibSM?rel=0&showinfo=0" frameborder="0" height="196" width="304" padding="15px"></iframe>
          </div>                                                                                                                                      
          <div id="demo8"></div>                                                                                                                      
          <div id="demo9">                                                                                                                            
          <iframe allowfullscreen="" src="//www.youtube.com/embed/wDGUkK8Azxc?rel=0&showinfo=0" frameborder="0" height="192" width="304" padding="15px"></iframe>
          </div>                                                                                                                                    
          <div id="demo10"></div>                                                                                                                   
          <div id="demo11">                                                                                                                         
          <iframe allowfullscreen="" src="//www.youtube.com/embed/Ja8ks1QN08k?rel=0&showinfo=0" frameborder="0" height="190" width="304" padding="15px"></iframe>
          </div>                                                                                                                                      
          <div id="demo12"></div>                                                                                                                     
          <div id="demo13">                                                                                                                           
          <iframe allowfullscreen="" src="//www.youtube.com/embed/rap2uI87ZGE?rel=0&showinfo=0" frameborder="0" height="200" width="304" padding="15px"></iframe>
          </div>                                                                                                                                     
          <div id="demo14"></div>                                                                                                                    
          <div id="demo15">                                                                                                                          
          <iframe allowfullscreen="" src="//www.youtube.com/embed/z82WPAnib80?rel=0&showinfo=0" frameborder="0" height="195" width="304" padding="15px"></iframe>
          </div>                                                                                                                                    
          <div id="demo16"></div>                                                                                                                   
          <div id="demo17">                                                                                                                         
          <iframe allowfullscreen="" src="//www.youtube.com/embed/jEsD_LOclgc?rel=0&showinfo=0" frameborder="0" height="191" width="304" padding="15px"></iframe>
          </div>
          <div id="demo18"></div>
          <div id="demo19">
          <iframe allowfullscreen="" src="//www.youtube.com/embed/NOPSlBFaXtM?rel=0&showinfo=0" frameborder="0" height="202" width="304" padding="15px"></iframe>
      </div>
        <div id="demo20"> </div>
        <div id="demo21">
          <iframe allowfullscreen="" src="//www.youtube.com/embed/3Ci29QZW6qw?rel=0&showinfo=0" frameborder="0" height="202" width="304" padding="15px"></iframe>
          </div>
      </div>

      <!--
      <div id="container">
        <div id="resume1"></div>
        <a id="resume2" ></a>
        <div id="resume3"></div>
        <div id="resume4">-->
        <!--<iframe allowfullscreen="" src="//www.youtube.com/embed/ygB4Tp-nhH8?rel=0&showinfo=0" frameborder="0" height="106" width="210"></iframe>//-->
      <!--</div>-->
        <!--<div id="resume5"></div>-->
        <!--<div id="resume6"></div>-->
        <!--<div id="resume7"></div>
      </div>-->
  </div>
</template>

<script>
export default {
  name: 'Animation'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
    text-align:center;
    }
@charset "UTF-8";
#topContainer{
	margin: 0px;
	padding: 0px;
	float: left;
	height:2800px;
	width: 600px;
}
iframe{
    padding : 15px;
}
#demo1 {
  background-image: url("~@/assets/art/animation/Demo1.png");
  background-repeat: no-repeat;
	margin: 0px;
	padding: 0px;
	float: left;
	height:78px;
	width: 600px;
}
#demo2 {
  background-image: url("~@/assets/art/animation/Demo2.png");
  background-repeat: no-repeat;
	/* [disabled]margin: 0px auto 0px auto; */
	padding: 0px auto 0px auto;
	float: left;
	width: 600px;
	height: 372px;
}
#demo3 {
	background-image: url("~@/assets/art/animation/Demo3.png") ;
	margin: 0px;
	padding: 0px;
	float: left;
  width: 600px;
  height: 130px;
  background-repeat: no-repeat;
}
#demo4 {
  background-image: url("~@/assets/art/animation/Demo4.png");
  background-repeat: no-repeat;
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:239px;
}
#demo5 {
  background-image: url("~@/assets/art/animation/Demo5.png");
  background-repeat: no-repeat;
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:239px;
}
#demo6 {
	background-image: url("~@/assets/art/animation/Demo6.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:226px;
}
#demo7 {
	background-image: url("~@/assets/art/animation/Demo7.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:226px;
}
#demo8 {
	background-image: url("~@/assets/art/animation/Demo12.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:230px;
}
#demo9 {
	background-image: url("~@/assets/art/animation/Demo9.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:230px;
}
#demo10 {
	background-image: url("~@/assets/art/animation/Demo10.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:220px;
}
#demo11 {
	background-image: url("~@/assets/art/animation/Demo11.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:220px;
}
#demo12 {
	background-image: url("~@/assets/art/animation/Demo8.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:222px;
}
#demo13 {
	background-image: url("~@/assets/art/animation/Demo13.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:222px;
}
#demo14 {
	background-image: url("~@/assets/art/animation/Demo14.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:225px;
}
#demo15 {
	background-image: url("~@/assets/art/animation/Demo15.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:225px;
}
#demo16 {
	background-image: url("~@/assets/art/animation/Demo16.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:221px;
}
#demo17 {
	background-image: url("~@/assets/art/animation/Demo17.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:221px;
}
#demo18 {
	background-image: url("~@/assets/art/animation/Demo18.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:252px;
}
#demo19 {
	background-image: url("~@/assets/art/animation/Demo19.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:252px;
}
#demo20 {
	background-image: url("~@/assets/art/animation/Demo20.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 266px;
	height:252px;
}
#demo21 {
	background-image: url("~@/assets/art/animation/Demo21.png");
	margin: 0px;
	padding: 0px;
	float: left;
	width: 334px;
	height:252px;
}
#container {
	margin: 0px;
	padding: 0px;
	float: left;
	height: 6000px;
	width: 600px;
}
#resume1 {
	background-image: url("~@/assets/art/animation/resume1.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 74px;
	width: 536px;
}
#resume2 {
	background-image: url("~@/assets/art/animation/resume2.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 74px;
	width: 64px;
}
#resume3 {
	background-image: url("~@/assets/art/animation/resume3.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 106px;
	width: 172px;
}
#resume4 {
  background-image: url("~@/assets/art/animation/resume4.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 106px;
	width: 210px;
}
#resume5 {
	background-image: url("~@/assets/art/animation/resume5.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 106px;
	width: 154px;
}
#resume6 {
	background-image: url("~@/assets/art/animation/resume6.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 106px;
	width: 64px;
}
#resume7 {
	background-image: url("~@/assets/art/animation/resume7.gif");
	margin: 0px;
	padding: 0px;
	float: left;
	height: 5820px;
	width: 600px;
}
#video {
	z-index:100;
}

    
</style>
